
export const appCardTop = {
  marginTop: '5em'
};

export const lwLogo = require('../../imgs/LandingPageImage.jpg');

export const appCard = {
  boxShadow:
    '0 13px 35px -12px rgba(0, 0, 0, 0.56), 0 1px 22px 0px rgba(0, 0, 0, 0.12), 0 5px 7px -5px rgba(0, 0, 0, 0.2)',
  zIndex: 1,
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  wordWrap: 'break-word',
  backgroundClip: 'border-box',
  border: '1px solid rgba(0,0,0,.125)',
  borderRadius: '.25rem',
  backgroundColor: '#CCC',
  width: 780,
  maxWidth: '100%',
  backgroundImage: `url(${lwLogo})`
};

export const appLogo = {
  paddingTop: '2em',
  height: 68,
  width: 70
};

export const cardContent = {
  top: '50%',
  color: 'aliceblue',
  fontSize: '12px',
  maxHeight: '70%'
};

export const ghostButton = Hover => {
  return {
    boxShadow:
      '0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12)',
    padding: '15px 30px',
    height: 50,
    fontSize: 14,
    lineHeight: 5,
    borderRadius: 3,
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    backgroundColor: Hover ? 'rgba(0,0,0,0.45)' : 'rgba(255,255,255,0.45)',
    color: 'aliceblue',
    textDecoration: 'none'
  };
};

export const buttonRow = {
  paddingTop: '2em',
  paddingBottom: '2em'
};

export const buttonSkip = {
  paddingBottom: '2em'
};
